export enum Source {
  Barclaycard = "BARCLAYCARD",
  Yoello = "YOELLO",
  ZeroBubble = "ZEROBUBBLE",
  BNA = "BNA"
}